

import { SvgIcon, SvgIconProps } from "@mui/material";

export const MicIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 14.574a3.09 3.09 0 0 1-3.09-3.09V6.337A3.09 3.09 0 0 1 12 3.246v0a3.09 3.09 0 0 1 3.09 3.09v5.149a3.09 3.09 0 0 1-3.09 3.09" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.003 11.65A7.003 7.003 0 0 1 12 18.653v0a7.003 7.003 0 0 1-7.003-7.003M12 20.754v-2.101"/></svg>
  </SvgIcon>
);
